module.exports = __webpack_public_path__ + "img/educational-qualifications.957ae336.svg";